export default {
    "help.title": "Help Center & FAQ",
    "help.seo_description": "Find answers to your questions about CitoyenPro, subscriptions, and citizenship exam preparation.",
    "help.hero.title": "How can we help you?",
    "help.nav.back_home": "Back to Home",

    "help.categories.account.title": "Account & Login",
    "help.categories.account.desc": "Password issues, confirmation email not received, profile settings.",
    "help.categories.billing.title": "Billing & Subscription",
    "help.categories.billing.desc": "Change plan, cancel subscription, invoices, refunds.",
    "help.categories.content.title": "Content & Courses",
    "help.categories.content.desc": "Questions about the official guide, how quizzes work, mock exams.",
    "help.categories.support.title": "Technical Support",
    "help.categories.support.desc": "Report a bug, display issue, slow application.",

    "help.faq.title": "Common Questions",
    "help.faq.q1": "How do I reset my password?",
    "help.faq.a1": "If you've forgotten your password, click 'Forgot password' on the login page. You'll receive an email to create a new one.",
    "help.faq.q2": "Does the app work offline?",
    "help.faq.a2": "Currently, an internet connection is required for interactive quizzes. However, Standard and Premium subscribers can download PDFs for offline study.",
    "help.faq.q3": "How do I cancel my subscription?",
    "help.faq.a3": "You can cancel at any time from your Dashboard > My Subscription. Access remains active until the end of the paid period.",

    "help.contact.title": "Can't find your answer?",
    "help.contact.desc": "Our support team is here to help you Monday through Friday.",
    "help.contact.cta": "Contact Support"
};
